/**
 * Parse url params from a path and a record of url params and query params
 * @param path - The path to parse
 * @param options.urlParams - The record of url params
 * @param options.queryParams - The record of query params
 * @returns The parsed path
 */
export type ParseUrlOptions = {
  urlParams?: Record<string, string | number> | undefined;
  queryParams?: Record<string, string | number | boolean | null | undefined> | undefined;
};

export const parseUrl = (path: string, { urlParams, queryParams }: ParseUrlOptions): string => {
  const parsedPath = Object.keys(urlParams || {}).reduce((result, param) => {
    return result.replace(`:${param}/`, `${urlParams?.[param]}/`).replace(new RegExp(`:${param}$`), `${urlParams?.[param]}`);
  }, path);

  const parsedQueryParams = new URLSearchParams();
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => parsedQueryParams.set(key, `${value}`));
  }
  return parsedQueryParams.toString() !== '' ? `${parsedPath}?${parsedQueryParams.toString()}` : parsedPath;
};
